export default __webpack_public_path__ + "static/media/goal3.16540719.webp";